import React from "react";
import { useBilling } from "../store/BillingContext";
import { DocumentTable } from "../components/documents/DocumentTable";

export const QuotationsView: React.FC = () => {
  const { state, setActiveDoc } = useBilling();

  return (
    <section className="panel">
      <div className="panel-title">
        <h3>All Proposals & Quotations ({state.quotes.length})</h3>
      </div>

      <DocumentTable docs={state.quotes} onEdit={setActiveDoc} showConvert={true} />
    </section>
  );
};
